import { Injectable } from '@angular/core';
import { FirebaseData } from '../../../providers/firebase-data';
import { FirebaseStorage } from '../../../providers/firebase-storage';
import { Storage } from '@ionic/storage'; 
import firebase from 'firebase';
import { FireBaseObjectNames } from '../../../core/codes';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';

@Injectable()
export class ProductData {
    public realtimeDb: any;

    constructor(
        private firebaseData: FirebaseData, 
        private firebaseStorage: FirebaseStorage,
        private storage: Storage,
        public afw: AngularFireDatabaseWrapper,
        ) {
      this.realtimeDb = firebase.database();
    }

    public getProductDetail(id) {
        let strgRef = FireBaseObjectNames.DAM_PRODUCTS + '/' + id;
        var result = this.afw.object(strgRef);
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/modules/product/providers/product-data.ts